document.addEventListener('DOMContentLoaded', () => {
  const menuBtn = document.getElementById('menuBtn');
  const mainNav = document.getElementById('mainNav');
  const overlay = document.getElementById('overlay');

  if (!menuBtn || !mainNav || !overlay) return;

  const toggleMenu = (state) => {
    // Если state передан (true/false), используем его, иначе просто переключаем
    const isActive = typeof state === 'boolean' ? state : !mainNav.classList.contains('is-active');

    menuBtn.classList.toggle('is-active', isActive);
    mainNav.classList.toggle('is-active', isActive);
    overlay.classList.toggle('is-active', isActive);
    document.body.style.overflow = isActive ? 'hidden' : '';
  };

  // 1. Клик по кнопке (открыть/закрыть)
  menuBtn.addEventListener('click', (e) => {
    e.stopPropagation();
    toggleMenu();
  });

  // 2. Клик по оверлею (затемнению) — закрываем
  overlay.addEventListener('click', () => toggleMenu(false));

  // 3. Клик ТОЛЬКО по ссылкам внутри меню
  mainNav.querySelectorAll('.nav-link').forEach(link => {
    link.addEventListener('click', () => toggleMenu(false));
  });

  // Предотвращаем закрытие при клике внутри самой плашки меню (по пустому месту)
  mainNav.addEventListener('click', (e) => {
    e.stopPropagation();
  });
});